import PropTypes from 'prop-types';
import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';
import MediaQuery from 'react-responsive';
import ReactCollapse from 'react-collapse';

import ConfigsService from 'login/services/ConfigsService/ConfigsService.js';

import SignInForm from 'login/components/SignIn/SignInForm/SignInForm.jsx';
import Separator from 'login/components/Library/Separator/Separator.jsx';
import FacebookBtn from 'login/components/Library/FacebookBtn/FacebookBtn.jsx';

import 'login/components/GuestOrSignin/components/SignInSection/SigninSection.scss';

class SigninSection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sectionOpened: false,
        };

        this.onOpenSection = this.onOpenSection.bind(this);
    }

    onOpenSection() {
        this.setState({
            sectionOpened: !this.state.sectionOpened,
        });
    }

    render() {
        const { onLogin } = this.props;
        const faceBookBlock = ConfigsService.getFacebookAppId() && (
            <div>
                <div className="fb-login">
                    <FacebookBtn closeDialog={onLogin} />
                </div>
                <Separator />
            </div>
        );
        const sectionContent = (
            <div>
                {faceBookBlock}
                <SignInForm onLogin={onLogin} />
            </div>
        );

        const openSectionIcon = this.state.sectionOpened ? 'icon-chevron-thin-down reverse' : 'icon-chevron-thin-down';

        return (
            <div className="signin-section">
                <h3 className="sr-title-1 is-centered" onClick={this.onOpenSection}>
                    <icon className={openSectionIcon} />
                    {LocaleService.t('LOGIN.SIGN_IN_SECTION.TITLE')}
                </h3>
                <MediaQuery maxWidth={767}>
                    <ReactCollapse isOpened={this.state.sectionOpened} springConfig={{ stiffness: 170, damping: 29 }}>
                        {sectionContent}
                    </ReactCollapse>
                </MediaQuery>
                <MediaQuery minWidth={767}>{sectionContent}</MediaQuery>
            </div>
        );
    }
}

SigninSection.propTypes = {
    onLogin: PropTypes.func.isRequired,
};

SigninSection.displayName = 'SigninSection';

export default SigninSection;
